<template>
  <div>
    <!--商品监控  -->
    <baseBreadcrumb :page="$t('message.commodityMonitoring')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <!-- 全部 -->
          <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
          <!-- 待义乌确认 -->
          <el-tab-pane :label="$t('message.toBeConfirmedByYiwu') + `(${tabs[1].num})`" name="1"></el-tab-pane>
          <!-- 待运营确认 -->
          <el-tab-pane :label="$t('message.subjectToConfirmation') + `(${tabs[2].num})`" name="2"></el-tab-pane>
          <!-- 已确认 -->
          <el-tab-pane :label="$t('message.confirmed')" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 商品ID-->
        <div class="item">
          <el-input v-model="datas.goods_id" :placeholder="$t('message.goodsID')" class="Container"
            onfocus="this.select()" clearable />
        </div>
        <!-- 中文商品-->
        <div class="item">
          <el-input v-model="datas.title" :placeholder="$t('message.chineseName')" class="Container"
            onfocus="this.select()" clearable />
        </div>
        <!-- 开始日期-->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
            type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--  结束日期-->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
            default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--   处理类别-->
        <div class="item">
          <el-select v-model="datas.isPrompt" filterable :placeholder="$t('message.processingClass')">
            <el-option v-for="item in promptOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!--   监控原因-->
        <div class="item">
          <el-select v-model="datas.forbid_type" filterable :placeholder="$t('message.monitoringReason')">
            <el-option v-for="item in forbidTypeList" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.filter') }}</el-button>
        <!-- 添加监控商品 -->
        <div class="btn">
          <el-button type="success" @click="add" v-if="isAuth(407)">{{ $t('message.addMonitoredGoods')
            }}</el-button>
          <!-- 日本批量确认 -->
          <el-button type="primary" class="primary" @click="batchConfirmationInJapan" v-if="isAuth(410)">{{
            $t('message.batchConfirmationInJapan')
          }}</el-button>
        </div>
        <!-- 添加监控商品 -->
        <div class="btn">

        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" @selection-change="handleSelectionChange">
          <el-table-column label="NO" align="center" width="60px" prop="rowNumber"></el-table-column>
          <el-table-column align="center" width="60px" type="selection"></el-table-column>
          <!-- 商品ID -->
          <el-table-column :label="$t('message.goodsID')" align="center" prop="goods_id"></el-table-column>
          <!-- 中文品名 -->
          <el-table-column :label="$t('message.chineseName')" align="center" prop="title"></el-table-column>
          <!-- 商品主图 -->
          <el-table-column :label="$t('message.commodityMasterChart')" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="scope.row.link.goods_url" slot="reference" target="_blank">
                  <el-image :src="scope.row.pic" style="width: 60px; height: 60px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 人工添加图片 -->
          <el-table-column :label="$t('message.manuallyAddPictures')" align="center">
            <template slot-scope="scope">
              <el-image :src="item" alt="" v-for="(item, index) in scope.row.images" :key="index"
                style="width: 40px; height: 40px" :preview-src-list="[item]">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <!-- 处理类别 -->
          <el-table-column :label="$t('message.processingClass')" align="center">
            <template slot-scope="scope">
              <div class="template">
                <p> {{ scope.row.is_client_hide ? '前台搜索隐藏' : '前台搜索不隐藏' }}</p>
                <p> {{ scope.row.is_admin_notice ? '后台提醒' : '后台不提醒' }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 是否被海关拦截过 -->
          <el-table-column :label="$t('message.isCustomsIntercepted')" align="center" width="80">
            <template slot-scope="scope">
              {{ Number(scope.row.is_customs_intercepted) === 1 ? $t('message.are') : $t('message.no') }}
            </template>
          </el-table-column>
          <!-- 监控原因 -->
          <el-table-column :label="$t('message.monitoringReason')" align="center"
            prop="forbid_type_name"></el-table-column>
          <!-- 商品备注 -->
          <el-table-column :label="$t('message.commodityNote')" align="center" width="200">
            <template slot-scope="scope">
              <div class="remark-text">
                <p v-for="(line, index) in formatRemarkLines(scope.row.remark)" :key="index">{{ line }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 操作时间 -->
          <el-table-column :label="$t('message.operatingTime')" align="center" width="220">
            <template slot-scope="scope">
              <div class="template">
                <p>添加：{{ scope.row.created_at }}</p>
                <p>国内确认：{{ scope.row.china_confirm_at }}</p>
                <p>日本确认：{{ scope.row.japan_confirm_at }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 部门 -->
          <el-table-column :label="$t('message.department')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.created_admin.role != false ? scope.row.created_admin.role[0].organization.name : '' }}
              </p>
            </template>
          </el-table-column>
          <!-- 操作人员 -->
          <el-table-column :label="$t('message.operatingPersonne')" align="center" width="150">
            <template slot-scope="scope">
              <div class="template">
                <p>添加人：{{ scope.row.created_admin ? scope.row.created_admin.realname : '' }}</p>
                <p>国内确认人：{{ scope.row.china_confirm_admin ? scope.row.china_confirm_admin.realname : '' }}</p>
                <p>日本确认人：{{ scope.row.japan_confirm_admin ? scope.row.japan_confirm_admin.realname : '' }}</p>
              </div>
            </template></el-table-column>
          <!-- 状态 -->
          <el-table-column :label="$t('message.status')" align="center" prop="status_name"></el-table-column>
          <!-- 运营备注 -->
          <el-table-column :label="$t('message.userRamrk')" align="center" width="150px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.operate_remark" @blur="updateOperateRemark(scope.row)" type="textarea"
                v-if="datas.status > 1">
              </el-input>
              <span v-else>
                {{ scope.row.operate_remark }}
              </span>
            </template>
          </el-table-column>
          <!--操作  -->
          <el-table-column :label="$t('message.operation')" align="center" width="100px" fixed="right">
            <template slot-scope="scope">
              <div class="operation">
                <!-- 修改 -->
                <el-button size="mini" type="primary" class="primary" @click="edit(scope.row)"
                  v-if="scope.row.status == 1 && isAuth(408)">{{ $t('message.edit')
                  }}</el-button>
                <!-- 确认 -->
                <el-button size="mini" class="primary" type="primary" @click="chinaConfirm(scope.row.id)"
                  v-if="scope.row.status == 1 && isAuth(409)">{{
                    $t('message.confirm') }}</el-button>
                <!-- 待运营确认 -->
                <el-button size="mini" class="primary" type="primary" @click="japanConfirm([scope.row.id])"
                  v-if="scope.row.status == 2 && isAuth(410)">{{
                    $t('message.subjectToConfirmation')
                  }}</el-button>
                <!-- 删除 -->
                <el-button size="mini" class="dark" type="primary" @click="forbidGoodsDelete(scope.row.id)"
                  v-if="isAuth(411)">{{
                    $t('message.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 添加修改 -->
    <monitorProductSettings :forbidTypeList="forbidTypeList" :isAdd="isAdd" :itemData="itemData"
      ref="monitorProductSettings" />
  </div>
</template>
<script>
import monitorProductSettings from './components/monitorProductSettings'
export default {
  components: {
    monitorProductSettings
  },
  data() {
    return {
      tabs: [{}, { num: 0 }, { num: 0 }, {},],
      isPrompt: '',//是否提示
      datas: {
        status: '',
        goods_id: '',
        dateStart: '',
        dateEnd: '',
        is_client_hide: '',
        is_admin_notice: '',
        forbid_type: '',
      },
      total: 0,
      promptOptions: [
        { value: '1', label: '客户搜索提示违禁' },
        { value: '2', label: '业务后台提示' }
      ],
      options: [],
      tableData: [],
      forbidTypeList: [],//违禁品列表
      isAdd: false,//是否新增
      itemData: {},
      multipleSelection: [],//多选
    };
  },
  created() {
    this.$api.siteConfiguration.forbidTypes().then(res => {


      this.forbidTypeList = res.data
    })
    this.forbidGoodsList()
    this.forbidGoodsListNum()
  },
  methods: {
    // 数量统计
    forbidGoodsListNum() {
      this.$api.tabTotalApi.forbidGoodsListNum().then(res => {
        this.tabs = res.data
      })
    },

    forbidGoodsList() {
      this.datas.is_client_hide = ''
      this.datas.is_admin_notice = ''
      if (this.isPrompt == 1) {
        this.datas.is_client_hide = '1'
      } else if (this.isPrompt == 2) {
        this.datas.is_admin_notice = '1'
      }
      this.multipleSelection = []
      this.$api.siteConfiguration.forbidGoodsList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(res);
      })
    },
    search() {
      this.datas.page = 1
      this.forbidGoodsList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.forbidGoodsList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.forbidGoodsList();
    },
    //新增
    add() {
      this.isAdd = true
      this.itemData = {
        goods_id: '',
        platform: '1688',
        forbid_type: '',
        is_client_hide: true,
        is_admin_notice: true,
        remark: '',
        images: [],
      }
      this.$refs.monitorProductSettings.dialogVisible = true
    },
    // 修改
    edit(item) {
      this.isAdd = false
      this.itemData = item
      this.$refs.monitorProductSettings.dialogVisible = true
    },
    // 删除
    forbidGoodsDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.forbidGoodsDelete({ id }).then((res) => {
            this.$message.success(res.msg);

            this.forbidGoodsList();
            this.forbidGoodsListNum()
          });
        })
        .catch(() => { });
    },

    //国内确认
    chinaConfirm(id) {
      this.$confirm(
        '业务员是否确认是违禁品？',
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.chinaConfirm({ id }).then((res) => {
            this.$message.success(res.msg);

            this.forbidGoodsList();
            this.forbidGoodsListNum()
          });
        })
        .catch(() => { });
    },
    //日本确认
    japanConfirm(ids) {
      this.$confirm(
        '此商品在日本确认是违禁品？',
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {

          this.$api.siteConfiguration.japanConfirm({ ids }).then((res) => {
            this.$message.success(res.msg);

            this.forbidGoodsList();
            this.forbidGoodsListNum()
          });
        })
        .catch(() => { });
    },
    handleSelectionChange() { },
    //日本批量确认
    batchConfirmationInJapan() {
      if (this.multipleSelection == false) return this.$t('message.selectableOperationalList')
      let ids = []
      this.multipleSelection.forEach(item => {
        ids.push(item.id)
      })
      this.japanConfirm(ids)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 修改运营备注
    updateOperateRemark(item) {
      let datas = {
        id: item.id,
        operate_remark: item.operate_remark
      }
      this.$api.siteConfiguration.updateOperateRemark(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    // 按换行符拆分备注（兼容真实换行与字面量 \n）
    formatRemarkLines(remark) {
      if (!remark) return []
      return String(remark).replace(/\\n/g, '\n').split('\n')
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin: 20px 0;
  position: relative;

  .item {
    margin-right: 12px;
  }

  /deep/.el-select,
  .el-input {
    width: 190px;
  }

  .btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.template {
  width: 100%;
  text-align: left;
}

.remark-text {
  text-align: left;

  p {
    margin: 0;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
}

.operation {


  .el-button {
    width: 70px;
    margin: 5px;
    padding: 10px 0;
    text-align: center;
  }
}

/deep/.el-textarea__inner {
  min-height: 100px !important;
  padding: 3px;
}
</style>